import { deleteRequest, downloadFile, get, patch, post} from 'utils/api';

export const addForm = async (data) => {
  return post('/form', data);
};

export const assignCharger = async (data) => {
  return post('/form/chargers', data);
};

export const fetchChargers = async () => {
  return get('/form/chargers');
};

export const fetchForms = async (data) => {
  return get('/form', data);
};

export const fetchForm = async (formId) => {
  return get('/form/' + formId);
};

export const updateForm = async (data) => {
  return patch('/form/' + data.formId, data.values);
};

export const deleteForm = async (formId) => {
  return deleteRequest('/form/' + formId);
};

//New Items
export const createChecklist = async (data) => {
  return post('/checklist/create', data);
};

export const fetchFromsList = async (data) => {
  return get('/checklist/stations', data);
};

export const fetchStationWiseFroms = async (data) => {
  const stationId = data
  return get(`/checklist/stations/${stationId}`);
};

export const submitForm = async (data) => {
  return post('/checklist/forms/submit', data);
};

export const viewForm = async (data) => {
  return post(`/checklist/forms/view/${data.formId}`,data);
};

export const downloadChecklistForm = async (data) => {
  return downloadFile(`/checklist/forms/download/${data.formId}`,data);
};

export const approveForm = async (data) => {
  return post(`/checklist/forms/changeStatus/${data.formId}`,data);
};

export const deleteChcecklistForm = async (data) => {
  return post(`/checklist/forms/delete/${data.formId}`,data);
};


export const assignToContractor = async (data) => {
  return post(`/checklist/forms/assignToContractor/${data.formId}`,data);
};


export const formApi = {
  addForm,
  assignCharger,
  fetchChargers,
  fetchForms,
  fetchForm,
  updateForm,
  deleteForm,
  createChecklist,
  fetchFromsList,
  fetchStationWiseFroms,
  submitForm,
  viewForm,
  downloadChecklistForm,
  approveForm,
  deleteChcecklistForm,
  assignToContractor
};
